"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHandler = void 0;
const router_1 = require("@keplr-wallet/router");
const messages_1 = require("./messages");
const getHandler = (service) => {
    return (env, msg) => {
        switch (msg.constructor) {
            case messages_1.LedgerGetWebHIDFlagMsg:
                return handleLedgerGetWebHIDFlagMsg(service)(env, msg);
            case messages_1.LedgerSetWebHIDFlagMsg:
                return handleLedgerSetWebHIDFlagMsg(service)(env, msg);
            default:
                throw new router_1.KeplrError("ledger", 111, "Unknown msg type");
        }
    };
};
exports.getHandler = getHandler;
const handleLedgerGetWebHIDFlagMsg = (service) => {
    return (_env, _msg) => __awaiter(void 0, void 0, void 0, function* () {
        return yield service.getWebHIDFlag();
    });
};
const handleLedgerSetWebHIDFlagMsg = (service) => {
    return (_env, msg) => __awaiter(void 0, void 0, void 0, function* () {
        return yield service.setWebHIDFlag(msg.flag);
    });
};
//# sourceMappingURL=handler.js.map